import { render, staticRenderFns } from "./purchaseReturnHistory.vue?vue&type=template&id=42a637ec&scoped=true"
import script from "./purchaseReturnHistory.vue?vue&type=script&lang=js"
export * from "./purchaseReturnHistory.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnHistory.vue?vue&type=style&index=0&id=42a637ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a637ec",
  null
  
)

export default component.exports